import { formatters } from "@/helpers/formatters";
import { InputDictionary } from "@/types/common";

export default <InputDictionary[]>[
  {
    title: "Date",
    value: "day",
    formatter: formatters.formatDate,
    table: { group: "dimensions", order: 10 },
  },
  {
    title: "Month",
    value: "month",
    formatter: formatters.formatMonth,
    table: { group: "dimensions", order: 11 },
  },
  {
    title: "Quarter",
    value: "quarter",
    formatter: formatters.formatQuarter,
    table: { group: "dimensions", order: 12 },
  },
];
